<template>
  <div>
    <el-row>
      <el-col>
        <el-button @click="addDepartment" size="medium">新增</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col>
        <el-table :data="departmentData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="80" min-width="80"></el-table-column>
          <el-table-column prop="TEMPLATE_NAME" label="模板名称"></el-table-column>
          <!-- <el-table-column prop="DEPARTMENT_NAME" label="部门"></el-table-column> -->
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDetail(scope.row)" icon="el-icon-edit">查看</el-button>
              <el-button type="text" size="small" @click="delDetail(scope.row)" icon="el-icon-edit">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalNum" style="float: right">
      </el-pagination>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="新增打印模板" center :visible.sync="addFormVisible" width="600px">
          <el-form :model="addForm" ref="addForm" :label-width="formLabelWidth">
            <el-form-item label="模板名称：" prop="NAME">
              <el-input v-model="addForm.NAME"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="close('addForm')">取 消</el-button>
            <el-button @click="submitAdd()">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      departmentData: [],
      editFormVisible: false,
      addFormVisible: false,
      editForm: {},
      addForm: {},
      formLabelWidth: '100px',
      currentPage: 1,
      totalNum: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
    };
  },
  mounted() {
    this.queryList();
  },
  methods: {
    // 删除
    delDetail(row) {
      this.$confirm('您确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          TC_ID: sessionStorage.getItem('companyId'),
          SERVICE_ID: '12013',
          OTYPE: 4,
          TEMPLATE_ID: row.TEMPLATE_ID,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryList();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    queryList() {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      http.post(params).then((result) => {
        this.departmentData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    close() {
      this.editForm.FIRST_TYPE_NAME = this.emp;
      this.addForm.FIRST_TYPE_NAME = '';
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.editForm = {};
      this.addForm = {};
    },
    addDepartment() {
      this.addFormVisible = true;
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '12013',
            OTYPE: 1,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: sessionStorage.getItem('tcId'),
            TEMPLATE_NAME: this.addForm.NAME,
          };
          if (!this.addForm.NAME) {
            this.$message.show({ text: '请填写名称', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addFormVisible = false;
            this.queryList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    openDetail(row) {
      this.$router.push({
        path: '/allPrint',
      });
      sessionStorage.setItem('TEMPLATE_ID', row.TEMPLATE_ID);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/setting/templatePrint.vue